
import { ContainerUser } from "@/models/ContainerUser";


export default {
  state: {
    user: {} as ContainerUser,
  },

  getters: {
    getProfileUser(state: any) {
      return state.user;
    },
  },
  mutations: {},
  actions: {},
};
